// FETCH ALL PRINTING INWARD_DC
export const FETCH_PRINTING_DC_INWARD_MASTER_REQUEST_DK = 'FETCH_PRINTING_DC_INWARD_MASTER_REQUEST_DK';
export const FETCH_PRINTING_DC_INWARD_MASTER_SUCCESS_DK = 'FETCH_PRINTING_DC_INWARD_MASTER_SUCCESS_DK';
export const FETCH_PRINTING_DC_INWARD_MASTER_FAILURE_DK = 'FETCH_PRINTING_DC_INWARD_MASTER_FAILURE_DK';

// CREATE PRINTING INWARD_DC
export const CREATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK = 'CREATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK';
export const CREATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK = 'CREATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK';
export const CREATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK = 'CREATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK';

// UPDATE PRINTING INWARD_DC
export const UPDATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK = 'UPDATE_PRINTING_DC_INWARD_MASTER_REQUEST_DK';
export const UPDATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK = 'UPDATE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK = 'UPDATE_PRINTING_DC_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF PRINTING INWARD_DC
export const FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_PRINTING_DC_INWARD_MASTER_FAILURE_DK';

// DELETE PRINTING INWARD_DC
export const DELETE_PRINTING_DC_INWARD_MASTER_REQUEST_DK = 'DELETE_PRINTING_DC_INWARD_MASTER_REQUEST_DK';
export const DELETE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK = 'DELETE_PRINTING_DC_INWARD_MASTER_SUCCESS_DK';
export const DELETE_PRINTING_DC_INWARD_MASTER_FAILURE_DK = 'DELETE_PRINTING_DC_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_PRINTING_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_PRINTING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_PRINTING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_PRINTING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_PRINTING_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_PRINTING_PO_IN_INWARD_FAILURE_DK';

export const RESET_PRINTING_DC_INWARD_MASTER_INFO_DK = 'RESET_PRINTING_DC_INWARD_MASTER_INFO_DK';

export const CREATE_PRINTING_DC_INWARD_MASTER_FORM_DK = 'CREATE_PRINTING_DC_INWARD_MASTER_FORM_DK';

export const UPDATE_PRINTING_DC_INWARD_MASTER_FORM_DK = 'UPDATE_PRINTING_DC_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_PRINTING_DC_INWARD_DETAILS_DK = 'NAVIGATE_PRINTING_DC_INWARD_DETAILS_DK';

// NAVIGATE TO PRINTING INWARD_DC COMPONENT
export const NAVIGATE_PRINTING_DC_INWARD_MASTER_DK = 'NAVIGATE_PRINTING_DC_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_PRINTING_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_PRINTING_INWARD_ID_DK';
export const SET_ACTIVE_KEY_PRINTING_INWARD_DK = 'SET_ACTIVE_KEY_PRINTING_INWARD_DK';

export const SET_PENDING_GRID_NAME_PRINTING_INWARD_DK = 'SET_PENDING_GRID_NAME_PRINTING_INWARD_DK';
export const SET_UNIT_NAME_PRINTING_INWARD_DK = 'SET_UNIT_NAME_PRINTING_INWARD_DK';


export const FETCH_COMPLETE_PRINTING_DC_IN_INWARD_REQUEST_DK = 'FETCH_COMPLETE_PRINTING_DC_IN_INWARD_REQUEST_DK';
export const FETCH_COMPLETE_PRINTING_DC_IN_INWARD_SUCCESS_DK = 'FETCH_COMPLETE_PRINTING_DC_IN_INWARD_SUCCESS_DK';
export const FETCH_COMPLETE_PRINTING_DC_IN_INWARD_FAILURE_DK = 'FETCH_COMPLETE_PRINTING_DC_IN_INWARD_FAILURE_DK';

export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';